<template>
  <div class="card custom-panel">
    <header class="card-header">
      <p class="card-header-title has-text-weight-normal">Internal notes:</p>
      <a @click.prevent="showHideReviewNotes" href="#" class="card-header-icon" aria-label="more options">
              <span class="icon">
                <i :class="[{ 'fa-minus': showNotes}, { 'fa-plus': !showNotes }, 'fas']" aria-hidden="true"></i>
              </span>
      </a>
    </header>
    <div v-if="showNotes" class="card-content is-clearfix">
      <div v-for="(note, index) in notes" class="margin-bottom-20">
        <div class="margin-bottom-5">
          <strong>{{ note.author }}</strong>
          on {{ note.datetime | prettyDateTime }}
        </div>
        <p v-html="note.content"></p>
      </div>

      <div class="field">
        <div class="control" :class="{'is-loading': creating_note}">
          <textarea :disabled="creating_note" v-model="new_note" class="textarea notesField"></textarea>
        </div>
      </div>

      <button :disabled="!new_note" @click.prevent="createNote" :class="[{ 'is-loading': creating_note }, 'button is-button-grey-outline is-pulled-right']">
        ADD NOTE
      </button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import misc from '../mixins/misc.js'

  export default {
    mixins: [misc],
    props: {
      reviewId: {
        required: true,
        type: Number
      }
    },
    data () {
      return {
        new_note: '',
        creating_note: false,
        notes: [],
        showNotes: true
      }
    },
    created () {
      axios.get(`/${this.reviewId}/internal-notes`)
            .then(({data}) => {
              for (let d of data) {
                this.notes.push({author: d.author.full_name, datetime: d.created_datetime, content: d.content})
              }
            })
    },
    methods: {
      /**
       * Create an internal Note
       * @returns {void}
       */
      createNote () {
        this.creating_note = true
        axios.post(`/${this.reviewId}/internal-notes`, {
          content: this.new_note
        })
          .then(({data}) => {
            this.creating_note = false
            this.notes.push({author: data.author, datetime: data.datetime, content: this.new_note})
            this.new_note = ''
          })
          .catch(() => {
            this.creating_note = false
          })
      }
    }
  }
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/widgets/InternalNotesWidget.vue